import React, { useContext, useEffect, useMemo, useState } from 'react'
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import moment from 'moment'
import { getFormatedDate, getTimeZoneTimeStamp} from '../../../../../Utils/UtilFunctions/pstTimeZoneFormatter'
import AccountPermission from '../../../../master/User/accountPermission/accountPermission'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import TextField from '@mui/material/TextField'
import { Typography } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { env } from '../../../../../env'
import HC_brokenAxis from 'highcharts/modules/broken-axis'
import AnnotationsModule from 'highcharts/modules/annotations'
import axios from 'axios'
import { PostAnnotations } from '../../../../../Utils/util'
import LoadingButton from '@material-ui/lab/LoadingButton'
import { AppContext } from '../../../../../App'

AnnotationsModule(Highcharts)
HC_brokenAxis(Highcharts)

interface Props {
	categories: any[]
	data: any[]
  dateRange: any
	height?: any
	width?: any
	getTag?: any
	tag?: any
	granularity?: any
	unit?: any
	limits?: any
}

function LineChart(props: any) {
  const appContextProps: any = useContext(AppContext);
  const plantsList = useSelector((state: any) => state.plantsList);
  const plantTimeZone = useMemo(() => {
    return (
		  plantsList?.plants?.find((p: any) => p.plant_code === appContextProps.selectedPlantForCube)?.plant_timezone ?? ""
    );
  }, [appContextProps.selectedPlantForCube, plantsList]);
  const plantName = useMemo(() => {
    return (
		  plantsList?.plants?.find((p: any) => p.plant_code === appContextProps.selectedPlantForCube)?.plant_name ?? ""
    );
  }, [appContextProps.selectedPlantForCube, plantsList]);
	const { isExtended = true } = props
	const dispatch = useDispatch()
	const usersList = useSelector((state: any) => state.usersList)
  const filteredData = props.data[0]?.data?.filter(
    (value: number) => value !== null && value !== undefined && !isNaN(value)
  );
  const minYAxisPoint = Math.round(Math.min(...filteredData));
  const maxYAxisPoint = Math.round(Math.max(...filteredData));
  const yAxisLimitPoints = useMemo(() => {
    let min = undefined;
    let max = undefined;
    if (
      maxYAxisPoint >= props?.limits?.LL &&
      maxYAxisPoint <= props?.limits?.UL &&
      minYAxisPoint >= props?.limits?.LL &&
      minYAxisPoint <= props?.limits?.UL
    ) {
      min =
        props?.limits?.LL || props?.limits?.LL === 0
          ? props?.limits?.LL - 1
          : undefined;
      max =
        props?.limits?.UL || props?.limits?.UL === 0
          ? props?.limits?.UL + 1
          : undefined;
    } else if (
      minYAxisPoint < props?.limits?.LL &&
      maxYAxisPoint < props?.limits?.UL
    ) {
      min = minYAxisPoint - 1;
      max =
        props?.limits?.UL || props?.limits?.UL === 0
          ? props?.limits?.UL + 1
          : undefined;
    } else if (
      maxYAxisPoint > props?.limits?.UL &&
      minYAxisPoint >= props?.limits?.LL
    ) {
      min =
        props?.limits?.LL || props?.limits?.LL === 0
          ? props?.limits?.LL - 1
          : undefined;
      max = maxYAxisPoint + 1;
    } else if (
      maxYAxisPoint > props?.limits?.UL &&
      minYAxisPoint < props?.limits?.LL
    ) {
      min = minYAxisPoint - 1;
      max = maxYAxisPoint + 1;
    } else {
      min =
        props?.limits?.LL || props?.limits?.LL === 0
          ? props?.limits?.LL - 1
          : undefined;
      max =
        props?.limits?.UL || props?.limits?.UL === 0
          ? props?.limits?.UL + 1
          : undefined;
    }
    return { min, max };
  }, [props?.data, props?.limits]);

  // const { selcetedPlant }: any = useSelector(
  // 	(state: any) => state.selectedPlantIM
  // )
  //const plantTimeZone = selectedPlantTZ;
	const [currentValue, setCurrentValue] = React.useState<any>([0, 0])
	const [open, setOpen] = React.useState(false)
	const [clickedTime, setClickedTime] = React.useState<any>(null)
	const [annotationText, setAnnotationText] = React.useState('')
  const handleClose = () => {
		setOpen(false)
	}
	const [isLoading, setIsLoading] = React.useState(false)

  const handleAddAnnotation = async () => {
		setIsLoading(true)
    const payload = {
      deviceName: "",
      tag: props.tag,
      annotationTimeStamp: currentValue[0],
			createdDateTime: moment()
				.utc()
				.format('YYYY-MM-DD HH:mm:ss'),
      username: usersList.currentUser.user_ad_name,
      plantName: plantName,
      granularity: props.granularity,
      annotation: annotationText,
			value: currentValue[1]
		}
		await PostAnnotations(
			payload
		)
      .then((response: any) => {
        // getAnnotations();
        // getAnnotationsForCurrentKPI();
				setOpen(false)
				setAnnotationText('')
        dispatch({
					type: 'LOAD_SNACKBAR',
          payload: {
            message:
							'Annotation successfully added. Added annotation might take some time to appear on KPI.',
						type: 'success',
						open: true
					}
				})
				setIsLoading(false)
      })
      .catch((error: any) => {
        dispatch({
					type: 'LOAD_SNACKBAR',
          payload: {
						message: 'Something went wrong! Failed to post annotations',
						type: 'error',
						open: true
					}
				})
				setIsLoading(false)
			})
	}

  const dateFormatter = (item: any) => {
    if (moment(item).isValid()) {
      //console.log('VJ item', item)
			const dateDifference = 2
      if (dateDifference <= 1) {
        return getFormatedDate(
          plantTimeZone,
          getTimeZoneTimeStamp(
            plantTimeZone,
						moment.tz(item, 'America/Los_Angeles').valueOf(),
						'YYYY-MM-DD hh:mma'
          ),
					'hh:mma'
				)
      } else if (dateDifference < 365) {
        return getFormatedDate(
          plantTimeZone,
          getTimeZoneTimeStamp(
            plantTimeZone,
						moment.tz(item, 'America/Los_Angeles').valueOf(),
						'YYYY-MM-DD hh:mma'
          ),
					'MM/DD hh:mma'
				)
      } else {
        return getFormatedDate(
          plantTimeZone,
          getTimeZoneTimeStamp(
            plantTimeZone,
						moment.tz(item, 'America/Los_Angeles').valueOf(),
						'YYYY-MM-DD hh:mma'
          ),
					'M/DD/YY hh:mma'
				)
      }
      // return moment(item).format("M/DD/YY hh:mmA");
    } else {
			return item
    }
	}

  const annotationsArray = props.fetchedAnnotations
    ?.filter((ele: any) => {
			return ele['Annotations.tagName'] === props.tag
    })
    ?.map((ele: any) => {
      return {
				draggable: '',
        labels: [
          {
            point: {
							y: ele['Annotations.datapoint'],
              // y: props.data[0].data[
              //   props.categories.indexOf(
              //     moment(ele["Annotations.timestamp"]).format(
              //       "M/DD/YY hh:mmA"
              //     )
              //   )
              // ],
							x: props.categories.indexOf(ele['Annotations.timestamp']),

              xAxis: 0,
							yAxis: 0
            },
            style: {
							textOverflow: 'ellipsis',
							width: 30
            },
            text: `Annotated value : ${
							ele['Annotations.datapoint']
						}\nAnnotated by: ${ele['Annotations.user_annotation']?.substring(
              0,
							ele['Annotations.user_annotation'].indexOf(':')
						)}\n${ele['Annotations.user_annotation']?.substring(
							ele['Annotations.user_annotation'].indexOf(':') + 1,
							ele['Annotations.user_annotation'].length
						)}`
					}
				]
			}
		})

  const getFilteredDatesAndIndexes = (dateRange: any, categories: any) => {
  const [start, end] = dateRange.map((d: any) => new Date(d));
  const diffHrs = (end - start) / (1000 * 60 * 60);
  const updatedCategories = [
    ...categories.map((date: any) => new Date(date).valueOf()),
  ].reverse();
  let intervalMs: any;
  if (diffHrs <= 12)
    intervalMs = 30 * 60 * 1000; // 30 mins interval for 12 hrs
  else if (diffHrs <= 24)
    intervalMs = 60 * 60 * 1000; // 1 hour interval for 24 hrs
  else if (diffHrs <= 48)
    intervalMs = 2 * 60 * 60 * 1000; // 2 hours interval for 2 days
  else if (diffHrs <= 168)
    intervalMs = 8 * 60 * 60 * 1000; // 8 hours interval for 7 days
  else if (diffHrs <= 336)
    intervalMs = 12 * 60 * 60 * 1000; // 12 hours interval for 14 days
  else if (diffHrs <= 744)
    intervalMs = 1 * 24 * 60 * 60 * 1000; // 1 days interval for 30 days
  else if (diffHrs <= 2160)
    intervalMs = 3 * 24 * 60 * 60 * 1000; // 3 days interval for 90 days
  else if (diffHrs <= 4464)
    intervalMs = 7 * 24 * 60 * 60 * 1000; // 7 days interval for 6 months
  else if (diffHrs <= 8928)
    intervalMs = 15 * 24 * 60 * 60 * 1000; // 15 days interval for 1 year
  else if (diffHrs <= 17856)
    intervalMs = 30 * 24 * 60 * 60 * 1000; // 30 days interval for 2 years
  else if (diffHrs <= 26784)
    intervalMs = 50 * 24 * 60 * 60 * 1000; // 50 days interval for 3 years
  else intervalMs = 1 * 24 * 60 * 60 * 1000; // 1 day interval for default

  const filteredIndexes: any = [];
  let currentTime: any;
  let index: any;

  updatedCategories.forEach((ts: any) => {
    if (!currentTime) {
      currentTime = ts + intervalMs;
      index = updatedCategories.findIndex(
        (value: number) => value === currentTime
      );
    } else {
      currentTime = currentTime + intervalMs;
      index = updatedCategories.findIndex(
        (value: number) => value === currentTime
      );
    }
    if (index >= 0) {
      filteredIndexes.push(index);
    }
  });

  return filteredIndexes;
};

  const options = {
    chart: {
			backgroundColor: '#232A58',
			type: 'line',
			color: '#FFFFFF',
      width: props.width,
			zoomType: 'x',
      style: {
				fontFamily: 'Roboto'
      },
      marginLeft: null,
			height: isExtended ? 500 : 200
    },
    credits: { enabled: false },
    title: {
			text: 'Line chart',
      style: {
				display: 'none'
			}
    },

    legend: {
      enabled: isExtended,
      align: "center",
      verticalAlign: "bottom",
      symbolWidth: 5,
      symbolHeight: 8,
      color: "#FFFFFF",
      labels: {
        style: {
          color: "#FFF",
        },
      },
      backgroundColor: "#00000040",
      padding: 10,
      itemMarginBottom: 8,
      margin: 25,
      itemStyle: {
        color: "#ffffff",
        fontSize: "11px",
      },
      itemHoverStyle: {
        color: "#AAA",
      },
    },
    xAxis: {
      tickColor: "#FFFFFxF",
      categories: props.categories,
      //gridLineWidth: 0,
      type: "datetime",
      tickPixelInterval: 150,
      reversed: true,
      labels: {
        formatter: (object: any) => {
          return dateFormatter(object.value);
        },
        // format: '{value:%Y-%b-%e}',
        // //rotation: -60,
        // style: {
        // 	color: '#FFF',
        // 	fontSize: '9.5px'
        // }
        format: "{value:%m/%d %I:%M%p}",
        style: {
          fontSize: "12px",
          color: "#ffffff",
          fontStyle: "Roboto",
          textTransform: "none",
        },
        rotation: -45,
      },
      title: {
        // text: isExtended ? 'Values' : '',
        style: { color: "#FFF" },
      },
      gridLineWidth: isExtended ? 0.25 : 0.25,
      gridLineDashStyle: "shortdash",
      gridLineColor: isExtended ? "#bbbbbb" : "#bbbbbb",
      tickPositions: getFilteredDatesAndIndexes(
        props.dateRange,
        props.categories
      ),
    },
    yAxis: {
      //categories: isExtended,
      plotLines: [
        {
          color: "#E06060", //#FFA500",
          width: 1,
          value:
            props?.limits?.LL || props?.limits?.LL === 0
              ? props?.limits?.LL
              : undefined,
        },
        {
          color: "#E06060",
          width: 1,
          value:
            props?.limits?.UL || props?.limits?.UL === 0
              ? props?.limits?.UL
              : undefined,
        },
      ],
      min: yAxisLimitPoints?.min,
      max: yAxisLimitPoints?.max,
      alignTicks: false,
      tickColor: "#FFFFFF",
      gridLineWidth: isExtended ? 0.25 : 0,
      labels: {
        formatter: (object: any) => {
          return `${Math.round(object.value * 100) / 100}`;
        },
        style: {
          color: isExtended ? "#FFF" : "transparent",
        },
      },
      offset: isExtended ? undefined : 0,
      title: {
        text: props.unit, // Set the text dynamically from props.unit
        style: {
          color: "#FFFFFF", // White text color
        },
      },
      tickPositioner: function () {
        // 	const { tickPositions }: any = this
        // 	//("tickPositions", tickPositions);
        // 	//const xValues = tickPositions.map((point: any) => point[0]);
        // 	//("xValues", xValues);
        // 	const min = Math.min(...tickPositions);
        // 	const max = Math.max(...tickPositions);
        // 	const range = max - min;

        // 	//(min, max, range)

        // 	const padding = range === 0 ? 1 : range * 0.05; // Handle single-value edge case
        // 	const paddedMin = min - padding;
        // 	const paddedMax = max + padding;

        // 	// Calculate a "nice" tick interval for Y-axis
        // 	const approxTicks = 10; // Desired number of ticks
        // 	const rawInterval = range / approxTicks;
        // 	const magnitude = Math.pow(10, Math.floor(Math.log10(rawInterval)));
        // 	const niceInterval = Math.ceil(rawInterval / magnitude) * magnitude;

        // 	("niceInterval", niceInterval)
        // 	// Calculate a dynamic interval
        // 	// const roughTicks = 20; // Aim for approximately 10 ticks
        // 	// const rawInterval = range / roughTicks;

        // 	// // Round the interval to the nearest "nice" number
        // 	// const magnitude = Math.pow(10, Math.floor(Math.log10(rawInterval)));
        // 	// const niceInterval = Math.ceil(rawInterval / magnitude) * magnitude;

        // 	const ticks = [];
        // 	let startTick = Math.floor(paddedMin / niceInterval) * niceInterval;

        // 	// Ensure that the first tick is within the paddedMin range
        // 	if (startTick < paddedMin) {
        // 		startTick += niceInterval;  // Move the starting point to the next interval
        // 	}

        // 	// Generate ticks, making sure they don't exceed paddedMin and paddedMax
        // 	for (let tick = startTick; tick <= paddedMax; tick += niceInterval) {
        // 		// Only add ticks that are within the valid range
        // 		if (tick >= paddedMin && tick <= paddedMax) {
        // 			ticks.push(parseFloat(tick.toFixed(10))); // Preserve precision
        // 		}
        // 	}

        // 	// To avoid extra padding issues for decimal values, adjust the last tick
        // 	if (ticks[ticks.length - 1] < paddedMax) {
        // 		ticks.push(parseFloat(paddedMax.toFixed(10)));  // Add the max value as the last tick if it's within range
        // 	}

        // 	return ticks;

        // const { tickPositions }: any = this
        // let value = []
        // if (tickPositions.length <= 16) {
        // 	value = tickPositions.filter((data: any, i: any) => {
        // 		return i % 1 === 0
        // 	})
        // } else {
        // 	value = tickPositions.filter((data: any, i: any) => {
        // 		return i % 3 === 0
        // 	})
        // }
        // return value
				const { tickPositions }: any = this
				let value = []

        // Helper function to check if a number is decimal
				const isDecimal = (num: number): boolean => num % 1 !== 0
        if (tickPositions.some(isDecimal)) {
          // For decimal data
          if (tickPositions.length <= 16) {
						value = tickPositions.filter((data: any, i: any) => i % 1 === 0) // Keep all ticks
          } else {
						value = tickPositions.filter((data: any, i: any) => i % 2 === 0) // Skip every 2nd tick
          }
        } else {
          // For non-decimal data
          if (tickPositions.length <= 16) {
						value = tickPositions.filter((data: any, i: any) => i % 1 === 0) // Keep all ticks
          } else {
						value = tickPositions.filter((data: any, i: any) => i % 3 === 0) // Skip every 3rd tick
          }
        }
				return value
      },
      // min: (function () {
      // 	if (props.data !== undefined && props.data !== null && props.data.length > 0) {
      // 		const min = Math.min(...props.data);
      // 		const max = Math.max(...props.data);
      // 		const range = max - min;
      // 		const padding = range * 0.10;

      // 		return parseFloat((min - padding).toFixed(10)); // Preserve precision

      // 	}
      // })(),
      // max: (function () {
      // 	if (props.data !== undefined && props.data !== null && props.data.length > 0) {
      // 		const min = Math.min(...props.data);
      // 		const max = Math.max(...props.data);
      // 		const range = max - min;
      // 		const padding = range * 0.10;
      // 		return parseFloat((max + padding).toFixed(10)); // Preserve precision

      // 	}
      // })(),
      tickLength: 0,

      gridLineDashStyle: "longdash",
      gridLineColor: isExtended ? "#bbbbbb" : "transparent",
      // tickPositioner: function () {
      // 	const { tickPositions }: any = this
      // 	let value = []
      // 	if (tickPositions.length <= 16) {
      // 		value = tickPositions.filter((data: any, i: any) => {
      // 			return i % 2 === 0
      // 		})
      // 	} else {
      // 		value = tickPositions.filter((data: any, i: any) => {
      // 			return i % 4 === 0
      // 		})
      // 	}
      // 	return value
      // }
    },
    // plotOptions: {
    // 	series: {
    // 		marker: {
    // 			symbol: 'circle'
    // 		}
    // 	}
    // },
    tooltip: {
      backgroundColor: "#FFF",
      style: {
        color: "#000",
      },
      shared: true,
      formatter: function () {
        const temp: any = this;
        return `
	  ${getFormatedDate(
      plantTimeZone,
      getTimeZoneTimeStamp(
        plantTimeZone,
        moment.tz(temp.x, "America/Los_Angeles").valueOf(),
        "YYYY-MM-DD hh:mmA"
      ),
      "M/DD/YY hh:mmA z"
    )}
				${temp.points.map((point: any) => {
          return `<br>
					${point.series?.name}: 
				<b>
				${Math.round(point.y * 100) / 100}${` ` + props.unit || null}
				</b>`;
        })}
				${temp.points.map((point: any) => {
          return `<br>
					Lower Limit: 
				<b>
				${props?.limits?.LL || props?.limits?.LL === 0 ? props?.limits?.LL : null}
				</b>`;
        })}
				${temp.points.map((point: any) => {
          return `<br>
					Upper Limit: 
				<b>
				${props?.limits?.UL || props?.limits?.UL === 0 ? props?.limits?.UL : null}
				</b>`;
        })}
	 `;
      },
    },
    lang: {
      noData: "No data available",
    },
    noData: {
      style: {
        fontSize: "16px",
        fontWeight: "bold",
        color: "#666",
      },
    },
    plotOptions: {
      area: {
        stacking: "normal",
        lineWidth: 1,
        marker: {
          enabled: false,
        },
      },
      tooltip: {
        enabled: true,
      },
      series: {
        point: {
          events: {
            click: function (e: any) {
              //creating temporary array of series to find which series the clicked point belongs to
              //   const temp = props.data.map((ele: any) => {
              // 	return {
              // 	  ...ele,
              // 	  isAMatch:
              // 		ele.data[props.categories.indexOf(e.point.category)] ===
              // 		e.point.y,
              // 	};
              //   });
              //condition to check if clicked series is not for alarm or warning

              setOpen(true); //opening dialog for annotations
              setClickedTime(
                getFormatedDate(
                  plantTimeZone,
                  getTimeZoneTimeStamp(
                    plantTimeZone,
                    moment.utc(e.point.category).valueOf(),
                    "YYYY-MM-DD hh:mmA"
                  ),
                  "YYYY-MM-DD hh:mmA z"
                )
              );
              setCurrentValue([
                moment(e.point.category).format("YYYY-MM-DD HH:mm:ss"),
                e.point.y,
              ]);
            },
          },
        },
        marker: {
          enabled: false,
        },
        label: {
          connectorAllowed: false,
        },
        connectNulls: true,
      },
    },
    series: props.data,
    annotations: annotationsArray,
  };

	return (
		<>
			<HighchartsReact highcharts={Highcharts} options={options} />

			<AccountPermission
				pageName='AssetReport'
				module='usecase'
				action='create'
			>
				<Dialog
					open={open}
					onClose={handleClose}
					aria-labelledby='alert-dialog-title'
					aria-describedby='alert-dialog-description'
				>
					<DialogTitle style={{ fontSize: '18px' }} id='alert-dialog-title'>
						Add Annotation
					</DialogTitle>
					<DialogContent>
						<DialogContentText id='alert-dialog-description'>
							<Typography style={{ marginBottom: '10px', width: '400px' }}>
								Adding annotation at- {clickedTime}
							</Typography>
							<TextField
								id='outlined-multiline-static'
								// label="Multiline"
								onChange={(event: any) => {
									setAnnotationText(event?.target.value)
								}}
								placeholder='Add annotation...'
								fullWidth
								// defaultValue="Default Value"
							/>
						</DialogContentText>
					</DialogContent>
					<DialogActions>
						<Button variant='contained' onClick={handleClose} autoFocus>
							Cancel
						</Button>
						
						<LoadingButton
							loading={isLoading}
							loadingPosition="end"
							variant="contained"
							autoFocus
							disabled={annotationText === ''}
							onClick={handleAddAnnotation}
						>
							Add
						</LoadingButton>
					</DialogActions>
				</Dialog>
			</AccountPermission>
		</>
	)
}

export default LineChart
